import { call, put, select } from 'redux-saga/effects'

import { authSelector } from '@/hooks/useAuth'
import type { AuthState } from '@/types'
import { InternalInboxActions } from '../actions'
import { inboxClient } from '../client'
import type { WorkspaceUnread } from '../types'

// Counts are decoration over the dashboard: a failed poll leaves the badge as
// it was and says nothing to the user
export function* fetchUnread() {
  const auth: AuthState = yield select(authSelector)

  if (!auth.authenticated) {
    return
  }

  try {
    const counts: WorkspaceUnread[] = yield call(inboxClient.unread)

    yield put(InternalInboxActions.setUnread(counts))
  } catch (error) {
    console.error('Error fetching inbox counts:', error)
  }
}
